'use client';

import {OnePaneLayoutContainer} from '@udemy-v2/react-layout-components';
import styles from '@/features/organization-team-plan/organization-signup-text.module.scss';
import {Panel} from '@udemy-v2/react-structure-components';
import {BlockList} from '@udemy-v2/react-core-components';
import {Icon} from '@udemy-v2/icons';
import {useFormatNumber, useI18n} from '@udemy-v2/i18n';

const APPROX_COURSE_COUNT = 28000;
const APPROX_EXAM_COUNT = 200;

export function OrganizationSignupText() {
    const {gettext, interpolate} = useI18n();
    const {formatNumber} = useFormatNumber();
    return (
        <OnePaneLayoutContainer className={styles.container}>
            <p className={styles.description}>
                {gettext(
                    'Create an account to try Udemy Business. When you’re ready, upgrade your account for full access.',
                )}
            </p>
            <Panel border={false} className={styles.panel}>
                <BlockList size="small">
                    <BlockList.Item
                        key={1}
                        icon={<Icon glyph="merchandise-course" label={false} />}
                    >
                        {interpolate(
                            gettext(
                                'Access to %(courses)s top courses and certification prep for %(exams)s exams.',
                            ),
                            {
                                courses: `${formatNumber(APPROX_COURSE_COUNT)}+`,
                                exams: `${formatNumber(APPROX_EXAM_COUNT)}+`,
                            },
                            true,
                        )}
                    </BlockList.Item>
                    <BlockList.Item key={2} icon={<Icon glyph="sparkles" label={false} />}>
                        {gettext(
                            'AI role play, coding exercises and practice tests to build real-world skills.',
                        )}
                    </BlockList.Item>
                    <BlockList.Item key={3} icon={<Icon glyph="data-insight" label={false} />}>
                        {gettext(
                            'Analytics, adoption reports and recommendations to direct learners for admins.',
                        )}
                    </BlockList.Item>
                </BlockList>
            </Panel>
        </OnePaneLayoutContainer>
    );
}
